export interface DateRangeSelection {
  startDate: Date
  endDate: Date
  key?: string
}

export function sortImagesNewestFirst<T extends { taken_on: string }>(
  images: T[],
): T[] {
  return [...images].sort(
    (a, b) => new Date(b.taken_on).getTime() - new Date(a.taken_on).getTime(),
  )
}

export function filterImagesByDateRange<T extends { taken_on: string }>(
  images: T[],
  dateRange: DateRangeSelection | null | undefined,
): T[] {
  if (!dateRange?.startDate || !dateRange?.endDate) {
    return images
  }
  return images.filter(image => {
    const takenOn = new Date(image.taken_on)
    return takenOn >= dateRange.startDate && takenOn <= dateRange.endDate
  })
}

export function selectImagesForDateRange<T extends { taken_on: string }>(
  images: T[],
  dateRange: DateRangeSelection | null | undefined,
): T[] {
  return sortImagesNewestFirst(filterImagesByDateRange(images, dateRange))
}
